<template>
  <div class="flex flex-col text-center rounded-lg px-4 bg-brand-light-sand max-w-lg mx-auto">
    <div id="inline-preview"></div>
  </div>
</template>
<script>
export default {
  name: 'DesignPreview',

  computed: {},
};
</script>
